import {
  faBriefcase,
  faCogs,
  faFile,
  faGraduationCap,
  faLanguage,
  faPlus,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import "../style/style-form-cv.css";
import FormProfile from "./form-profile";
import FormFormation from "./form-formation";
import FormExperience from "./form-experience";
import FormLangue from "./form-langue";
import FormCompetence from "./form-competence";
import FormDocument from "./form-document";
import axios from "../axios/axios";
import Cookies from "js-cookie";

function FormCv(props) {
  const token = Cookies.get("auth_token");
  const idoffre = Cookies.get("idoffre");
  const addPJ = Cookies.get("addPJ");
  const [offreEmploi, setOffreEmploi] = useState({});
  const [chargement, setChargement] = useState(false);
  const formWizardRef = useRef(null);
  const [domaines, setDomaines] = useState([]);
  const [allFormations, setAllFormations] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    getDomainesEtEtablissementsEtEntreprises();
    getOffreEmplPourPostuler();
  }, []);

  const getDomainesEtEtablissementsEtEntreprises = () => {
    axios
      .get("/getDomainesEtEtablissementsEtEntreprises", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setDomaines(response.data.domaines);
        setAllFormations(response.data.allFormation);
        if (addPJ != null) {
          if (formWizardRef.current && formWizardRef.current.goToTab) {
            formWizardRef.current.goToTab(5);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getOffreEmplPourPostuler = () => {
    setChargement(true);
    if (idoffre != null) {
      axios
        .get(`/getOffrePourPostuler/${idoffre}`, {
          headers: {
            Accept: "application/json",
          },
        })
        .then((response) => {
          setOffreEmploi(response.data.offeremp);
          if (addPJ != null) {
            if (formWizardRef.current && formWizardRef.current.goToTab) {
              formWizardRef.current.goToTab(5);
            }
          }
          setChargement(false);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setChargement(false);
    }
  };

  const handelChangeTab = () => {
    if (formWizardRef.current && formWizardRef.current.goToTab) {
      formWizardRef.current.goToTab(5);
    }
  };

  return (
    <>
      {chargement == true ? (
        <div className="container card text-center mt-5">
          <h4>Chargement .... </h4>
        </div>
      ) : (
        <div
          className="container"
          style={{ padding: "15px", marginTop: 10, marginBottom: 10 }}
        >
          <p
            style={{
              fontWeight: "800",
              fontSize: "22px",
              margin: 0,
              color: "#6A6A6A",
            }}
          >
            Mettre à jour mon Cv {idoffre != null ? "et postuler" : null}
          </p>

          <FormWizard
            ref={formWizardRef}
            shape="circle"
            color="#4361ee"
            onComplete={props.handleSave}
          >
            <FormWizard.TabContent
              title="Profile"
              icon={
                <FontAwesomeIcon icon={faUser} className="arrow-in-profile" />
              }
            >
              <FormProfile
                image={props.image}
                imageVisualise={props.imageVisualise}
                civilite={props.civilite}
                nom={props.nom}
                telephone={props.telephone}
                dateNaissance={props.dateNaissance}
                displayphoto={props.displayphoto}
                handleRadioChange={props.handleRadioChange}
                email={props.email}
                domaineEtude={props.domaineEtude}
                niveau={props.niveau}
                description={props.descriptionCv}
                msgProfile={props.msgErreurTap1}
                onChangeNom={props.onChangeNom}
                onChangeImage={props.onChangeImage}
                onChangeCivilite={props.onChangeCivilite}
                onChangeTelephone={props.onChangeTelephone}
                onChangeDateNaissance={props.onChangeDateNaissance}
                onChangeEmail={props.onChangeEmail}
                onChangeDomaineEtude={props.onChangeDomaineEtude}
                onChangeNiveau={props.onChangeNiveau}
                onChangeDescription={props.onChangeDescription}
                domaines={domaines}
              />
            </FormWizard.TabContent>

            <FormWizard.TabContent
              title="Formations"
              icon={
                <FontAwesomeIcon
                  icon={faGraduationCap}
                  className="arrow-in-profile"
                />
              }
              isValid={props.checkValidateTabProfile()}
              validationError={props.errorMessagesTabProfile}
            >
              <div
                style={{
                  background: "#f1f4fa",
                  marginTop: 5,
                  border: "1px solid rgba(0, 0, 0, 0.1)",
                  borderRadius: "20px",
                  padding: "10px",
                }}
              >
                <p style={{ textAlign: "start" }} className="p titre-steep">
                  Quels sont vos diplômes ?
                </p>
                <p style={{ textAlign: "start" }} className="p sub-titre-steep">
                  Commencez par vos études les plus récentes et remontez dans le
                  passé. Si vous avez suivi de nombreuses études, n'ajoutez que
                  les plus récentes et pertinentes.
                </p>
                <FormFormation
                  formations={props.formations}
                  onChangeFormation={props.handleChangeFormation}
                  msgErrFormation={props.msgErreurTabFormation}
                  msgErrEncoure={props.msgErreurEncourForma}
                  msgDateForm={props.msgDateForm}
                  onSupprimerFormation={props.handleSupprimerFormation}
                  onToggleEncoureFormation={props.handleCheckboxChangeFormation}
                  onChangeEtablissement={props.onChangeEtablissement}
                  filteredResultsEtablissement={
                    props.filteredResultsEtablissement
                  }
                  searchInputEtablissement={props.searchInputEtablissement}
                  selectItemsEtablissement={props.selectItemsEtablissement}
                  currentIndex={props.currentIndex}
                />

                <div style={{ marginTop: "10px" }}>
                  <p
                    onClick={props.handleAjouterFormation}
                    style={{
                      fontWeight: "700",
                      fontSize: "15px",
                      color: "red",
                      textAlign: "start",
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} /> Ajouter une autre
                    formation
                  </p>
                </div>
              </div>
            </FormWizard.TabContent>

            <FormWizard.TabContent
              title="Experiences"
              icon={
                <FontAwesomeIcon
                  icon={faBriefcase}
                  className="arrow-in-profile"
                />
              }
              isValid={props.checkValidateTabFormation()}
              validationError={props.errorMessagesTabFormation}
            >
              <div
                style={{
                  background: "#f1f4fa",
                  marginTop: 5,
                  border: "1px solid rgba(0, 0, 0, 0.1)",
                  borderRadius: "20px",
                  padding: "10px",
                }}
              >
                <br />
                <p style={{ textAlign: "start" }} className="p titre-steep">
                  Indiquez vos expériences professionnelles
                </p>
                <p style={{ textAlign: "start" }} className="p sub-titre-steep">
                  Commencez par votre poste actuel et remontez dans le passé. Si
                  vous avez beaucoup d'expériences, n'ajoutez que les postes les
                  plus récents et pertinents.
                </p>
                <br />
                <FormExperience
                  experiences={props.experiences}
                  onChangeExperience={props.handleChangeExperience}
                  onSupprimerExperience={props.handleSupprimerExperience}
                  msgErreurEncourExper={props.msgErreurEncourExper}
                  msgErrExperience={props.msgErreurTabExperience}
                  msgErrDateExper={props.msgErrDateExper}
                  onToggleEncoureExperiance={
                    props.handleCheckboxChangeExperience
                  }
                  onChangeEntreprise={props.onChangeEntreprise}
                  filteredResultsEntreprise={props.filteredResultsEntreprise}
                  searchInputEntreprise={props.searchInputEntreprise}
                  selectItemsEntreprise={props.selectItemsEntreprise}
                  currentIndex={props.currentIndex}
                />

                <div style={{ marginTop: "10px" }}>
                  <p
                    onClick={props.handleAjouterExperience}
                    style={{
                      fontWeight: "700",
                      fontSize: "15px",
                      color: "red",
                      textAlign: "start",
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} /> Ajouter une autre
                    experience
                  </p>
                  {props.experiences.map((experience, index) =>
                    props.experiences.length == 1 &&
                    experience.moisDebutExper == "" &&
                    experience.anneeDebutexper == "" &&
                    experience.moisFinExper == "" &&
                    experience.anneeFinexper == "" &&
                    experience.encoureEper == "" &&
                    experience.titreProjet == "" &&
                    experience.nomEntreprise == "" ? (
                      <p
                        key={{ index }}
                        style={{
                          fontWeight: "600",
                          fontSize: "13px",
                          color: "red",
                          textAlign: "end",
                        }}
                      >
                        N'avez vous pas d'expériences à ajouter ?
                      </p>
                    ) : null
                  )}
                </div>
              </div>
            </FormWizard.TabContent>

            <FormWizard.TabContent
              title="Langue"
              icon={
                <FontAwesomeIcon
                  icon={faLanguage}
                  className="arrow-in-profile"
                />
              }
              isValid={props.checkValidateTabExperience()}
              validationError={props.errorMessagesTabExperience}
            >
              <FormLangue
                langues={props.langues}
                handleAjouterLangue={props.handleAjouterLangue}
                msgErrLangue={props.msgErreurTabLangue}
                onChangeLangue={props.handleChangeLangue}
                onSupprimerLangue={props.handleSupprimerLangue}
              />
            </FormWizard.TabContent>

            <FormWizard.TabContent
              title="Compétences"
              icon={
                <FontAwesomeIcon icon={faCogs} className="arrow-in-profile" />
              }
              isValid={props.checkValidateTabLangue()}
              validationError={props.errorMessagesTapLangue}
            >
              <FormCompetence
                competences={props.competences}
                onSupprimerCompetence={props.handleSupprimerCompetence}
                msgErrCmpetence={props.msgErreurTabCompetance}
                onChangeCompetence={props.handleChangeCompetence}
                handleAjouterCompetence={props.handleAjouterCompetence}
              />
            </FormWizard.TabContent>

            {offreEmploi != null && offreEmploi.have_pj == 1 ? (
              <FormWizard.TabContent
                title="Documents"
                icon={
                  <FontAwesomeIcon icon={faFile} className="arrow-in-profile" />
                }
                isValid={props.checkValidateTabCompetance()}
                validationError={props.errorMessagesTabLangueCompetance}
              >
                <FormDocument
                  piecejointes={props.piecejointes}
                  onSupprimerPiecejointe={props.handleSupprimerPiecejointe}
                  onChangePiecejointe={props.handleChangePiecejointe}
                  handleAjouterPiecejointe={props.handleAjouterPiecejointe}
                  list={props.list}
                  ChangePJ={props.ChangePJ}
                  removeFichier={props.removeFichier}
                  ajouterAuterFichier={props.ajouterAuterFichier}
                />
              </FormWizard.TabContent>
            ) : null}
          </FormWizard>
        </div>
      )}
    </>
  );
}

export default FormCv;
